module.exports = __webpack_public_path__ + "img/Gruppenführer_W.a91f5b95.svg";